// Recovered compiled webpack factory 16649. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    BD: () => s,
    Kg: () => u,
    L2: () => v,
    NF: () => c,
    Qd: () => d,
    Qg: () => m,
    T2: () => i,
    W6: () => l,
    bJ: () => a,
    gd: () => _,
    ks: () => b,
    mE: () => g,
    sO: () => f,
    tH: () => y,
    vq: () => h,
    xH: () => p,
  });
  let n = Object.prototype.toString;
  function a(e) {
    switch (n.call(e)) {
      case "[object Error]":
      case "[object Exception]":
      case "[object DOMException]":
      case "[object WebAssembly.Exception]":
        return !0;
      default:
        return y(e, Error);
    }
  }
  function o(e, t) {
    return n.call(e) === `[object ${t}]`;
  }
  function i(e) {
    return o(e, "ErrorEvent");
  }
  function s(e) {
    return o(e, "DOMError");
  }
  function l(e) {
    return o(e, "DOMException");
  }
  function u(e) {
    return o(e, "String");
  }
  function c(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      "__sentry_template_string__" in e &&
      "__sentry_template_values__" in e
    );
  }
  function f(e) {
    return null === e || c(e) || ("object" != typeof e && "function" != typeof e);
  }
  function d(e) {
    return o(e, "Object");
  }
  function p(e) {
    return "undefined" != typeof Event && y(e, Event);
  }
  function h(e) {
    return "undefined" != typeof Element && y(e, Element);
  }
  function _(e) {
    return o(e, "RegExp");
  }
  function m(e) {
    return !!(e?.then && "function" == typeof e.then);
  }
  function g(e) {
    return d(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
  }
  function y(e, t) {
    try {
      return e instanceof t;
    } catch {
      return !1;
    }
  }
  function v(e) {
    return !!("object" == typeof e && null !== e && (e.__isVue || e._isVue || e.__v_isVNode));
  }
  function b(e) {
    return "undefined" != typeof Request && y(e, Request);
  }
}
